import styled from 'styled-components';

export const TableWeekHeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #d8d8da;
`;
